import APIClient from '@/shared/http/clients/api'

const resourceName = 'regulationautodigitationcomplementary'
const APIRegAuto = process.env.APIBaseURLRegulationAuto

const GetAll = (id, data = {}, config = {}) => APIClient.get(`${APIRegAuto}/${resourceName}/regulationautoid/${id}`, data, config)
const GetAllPaging = (id, limit, index, config = {}) => APIClient.get(`${APIRegAuto}/${resourceName}/regulationautoid/${id}?limit=${limit}&index=${index}`, config)
const GetById = (id, config = {}) => APIClient.get(`${APIRegAuto}/${resourceName}/${id}`, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APIRegAuto}/${resourceName}`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APIRegAuto}/${resourceName}`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APIRegAuto}/${resourceName}/${id}`, config)

const RegulationAutoDigitationComplementary = {
  GetAll,
  GetAllPaging,
  GetById,
  Create,
  Update,
  Delete
}

export default RegulationAutoDigitationComplementary



// WEBPACK FOOTER //
// ./src/shared/http/repositories/regulation/auto/regulationautotypingcomplement.js